import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import withBreakpoint from 'core/hocs/withBreakpoint';

import Link from 'core/components/Link';
import SmartImage from 'core/components/SmartImage';

import { denormalizeData } from 'core/utils/api';
import resolveRelationships from 'core/utils/relationships';

const relationships = resolveRelationships(
  ['image'],
  {},
  { image: { versions: {} } },
);

function Promo({ isMobile, className }, context) {
  const {
    bebopApi,
  } = context;

  const [promo, setPromo] = useState(null);

  useEffect(() => {
    bebopApi
      .getTopics({
        limit: 1,
        topic_type: 'promo',
        include: 'image',
        fields: 'link,headline',
      })
      .then(topics => {
        if (topics.data.length) {
          setPromo(denormalizeData(topics)[0]);
        }
      });
  }, []); // eslint-disable-line

  if (!promo) return null;

  const {
    link,
    headline,
  } = promo.attributes;

  const {
    image: {
      versions,
    },
    caption,
  } = relationships(promo);

  const altAndTitle = caption || headline;

  const linkTitle = headline;

  return (
    <div className={className}>
      <Link
        to={link}
        title={linkTitle}
        аria-label='Промо'
      >
        <SmartImage
          versions={versions}
          maxWidth={isMobile ? 104 : 208}
          height={isMobile ? 34 : 60}
          placement='contain'
          alt={altAndTitle}
          title={altAndTitle}
        />
      </Link>
    </div>
  );
}
Promo.propTypes = {
  content: PropTypes.array,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};

Promo.contextTypes = {
  bebopApi: PropTypes.object,
};

const PromoWithHOCs = withBreakpoint(Promo);

export { Promo as StorybookComponent };
export default PromoWithHOCs;
